export default __webpack_public_path__ + "static/genopets-3-c-57e38a83c2b98c67a8ef238765c53ff7.webp";